function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

function Chevron({
  height,
  width,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: width,
    height: height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.93 6.657L7.292.293a1 1 0 011.414 0l6.364 6.364a1 1 0 01-1.414 1.414L8 2.414 2.343 8.071A1 1 0 01.93 6.657z",
    fill: "#9095A8"
  }));
}

Chevron.defaultProps = {
  width: 16,
  height: 9
};
export default Chevron;